import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import { useParams } from 'react-router'
import { useFeatures } from '../../../hooks/Features/useFeatures'
import Loader from '../../Loader'

function AreaView({ area }) {
  const data = [
    { label: 'Area Code', data: area.areaCode },
    { label: 'Name', data: area.name },
    { label: 'Region', data: area.region ? area.region.name : '' },
    { label: 'Zone', data: area.zone ? area.zone.name : '' },
    { label: 'State', data: area.state ? area.state.name : '' },
    { label: 'District', data: area.district ? area.district.name : '' },
    { label: 'City', data: area.city ? area.city.name : '' },
  ]
  return (
    <Grid container>
      {area ? (
        <Grid item lg={12} container spacing={3}>
          {data.map((item, index) => (
            <Grid item lg={4} key={index}>
              <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                <Typography style={{ fontSize: '16px', fontWeight: 600 }}>{item.label}</Typography>
                <Typography style={{ fontSize: '14px', fontWeight: 400 }}>{item.data}</Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Loader />
      )}
    </Grid>
  )
}

export default AreaView
